module.exports = __webpack_public_path__ + "static/img/404.59c80802.svg";